export default __webpack_public_path__ + "static/media/tombergerP.5b1d0239.jpg";